const UNLIMITED = 'UNLIMITED'

/**
 * @description: 广告位大类 允许值： MANUAL 首选媒体，UNIVERSAL_SMART 通投智选
 */
export const INVENTORY_CATALOG = {
  MANUAL: 'MANUAL',
  UNIVERSAL_SMART: 'UNIVERSAL_SMART'
}

/**
 * @description: 广告投放位置（首选媒体），inventory_catalog = MANUAL 首选媒体有效且必填
 */
export const INVENTORY_TYPE = {
  INVENTORY_FEED: 'INVENTORY_FEED',
  INVENTORY_VIDEO_FEED: 'INVENTORY_VIDEO_FEED',
  INVENTORY_AWEME_FEED: 'INVENTORY_AWEME_FEED',
  INVENTORY_TOMATO_NOVEL: 'INVENTORY_TOMATO_NOVEL',
  INVENTORY_UNION_SLOT: 'INVENTORY_UNION_SLOT',
  UNION_BOUTIQUE_GAME: 'UNION_BOUTIQUE_GAME',
  INVENTORY_UNIVERSAL: 'INVENTORY_UNIVERSAL',
  INVENTORY_SEARCH: 'INVENTORY_SEARCH'
}

/**
 * @description: 投放形式（穿山甲视频创意类型） inventory_catalog = MANUAL && inventory_type 仅有 INVENTORY_UNION_SLOT 时 有效且必填；
 */
export const UNIOIN_VIDEO_TYPE = {
  REWARDED_VIDEO: 'REWARDED_VIDEO',
  ORIGINAL_VIDEO: 'ORIGINAL_VIDEO',
  SPLASH_VIDEO: 'SPLASH_VIDEO'
}

/**
 * @description: 是否开启人群包定向
 */
export const AUDIENCE_TYPE = {
  UNLIMITED,
  AUDIENCE: 'AUDIENCE'
}

/**
 * @description: 是否开启地区定向
 */
export const REGION_TYPE = {
  UNLIMITED,
  REGION: 'REGION'
}

export const DISTRICT_TYPE = {
  NONE: 'NONE',
  REGION: 'REGION'
}

export const LOCATION_TYPE = {
  HOME: 'HOME',
  TRAVEL: 'TRAVEL',
  ALL: 'ALL',
  CURRENT: 'CURRENT'
}

/**
 * @description: 是否开启性别定向
 */
export const GENDER_TYPE = {
  UNLIMITED: 'NONE',
  GENDER_MALE: 'GENDER_MALE',
  GENDER_FEMALE: 'GENDER_FEMALE'
}

/**
 * @description: 年龄
 */
export const AGE_TYPES = {
  MORE: 'MORE',
  UNLIMITED: 0,
  AGE_BETWEEN_18_23: 'AGE_BETWEEN_18_23',
  AGE_BETWEEN_24_30: 'AGE_BETWEEN_24_30',
  AGE_BETWEEN_31_40: 'AGE_BETWEEN_31_40',
  AGE_BETWEEN_41_49: 'AGE_BETWEEN_41_49',
  AGE_ABOVE_50: 'AGE_ABOVE_50',
  AGE_BETWEEN_18_19: 'AGE_BETWEEN_18_19',
  AGE_BETWEEN_20_23: 'AGE_BETWEEN_20_23',
  AGE_BETWEEN_31_35: 'AGE_BETWEEN_31_35',
  AGE_BETWEEN_36_40: 'AGE_BETWEEN_36_40',
  AGE_BETWEEN_41_45: 'AGE_BETWEEN_41_45',
  AGE_BETWEEN_46_50: 'AGE_BETWEEN_46_50',
  AGE_BETWEEN_51_55: 'AGE_BETWEEN_51_55',
  AGE_BETWEEN_56_59: 'AGE_BETWEEN_56_59',
  AGE_ABOVE_60: 'AGE_ABOVE_60'
}

/**
 * @description: 行为兴趣 允许值：UNLIMITED 不限、CUSTOM 自定义、 RECOMMEND系统推荐
 */
export const INTEREST_ACTION_TYPES = {
  UNLIMITED,
  CUSTOM: 'CUSTOM',
  RECOMMEND: 'RECOMMEND'
}

/**
 * @description: 平台类型
 */
export const PLATFORM = {
  UNLIMITED,
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  HARMONY: 'HARMONY'
}

/**
 * @description: 过滤已转化用户
 * @description: 可以避免该广告再次投放给已转化过的用户允许值：NO_EXCLUDE 不限制、PROMOTION 广告、PROJECT 项目、ADVERTISER 广告账户、APP 应用、CUSTOMER 客户、ORGANIZATION 组织（仅加白广告主可用）
 */
export const HIDE_IF_CONVERTED = {
  NO_EXCLUDE: 'NO_EXCLUDE',
  PROMOTION: 'PROMOTION',
  PROJECT: 'PROJECT',
  ADVERTISER: 'ADVERTISER',
  APP: 'APP',
  CUSTOMER: 'CUSTOMER',
  ORGANIZATION: 'ORGANIZATION'
}

export const CONVERTED_TIME_DURATION = {
  NONE: 'NONE',
  ONE_MONTH: 'ONE_MONTH',
  SEVEN_DAY: 'SEVEN_DAY',
  SIX_MONTH: 'SIX_MONTH',
  THREE_MONTH: 'THREE_MONTH',
  TODAY: 'TODAY',
  TWELVE_MONTH: 'TWELVE_MONTH'
}

export const HIDE_IF_EXISTS = {
  UNLIMITED: 'UNLIMITED',
  FILTER: 'FILTER'
}

/**
 * @description: 是否过滤设备类型
 */
export const DEVICE_TYPE = {
  UNLIMITED: 'NONE',
  DEVICE: 'DEVICE'
}
/**
 * @description: 设备类型
 */
export const DEVICE_TYPE_CATEGORY = {
  UNLIMITED: 0,
  MOBILE: 'MOBILE',
  PAD: 'PAD'
}

/**
 * @description: 智能放量
 */
export const AUTO_EXTEND_ENABLE = {
  ON: 'ON',
  OFF: 'OFF'
}

/**
 * @description: 网络类型
 */
export const AC = {
  NONE: 0,
  WIFI: 'WIFI',
  AC2G: '2G',
  AC3G: '3G',
  AC4G: '4G',
  AC5G: '5G'
}

/**
 * @description: 媒体定向
 */
export const SUPERIOR_POPULARITY_TYPE = {
  UNLIMITED,
  GAME: 'GAME',
  CUSTOM: 'CUSTOM'
}

/**
 * @description: 运营商
 */
export const CARRIER_TYPE = {
  UNLIMITED: 0,
  MOBILE: 'MOBILE',
  UNICOM: 'UNICOM',
  TELCOM: 'TELCOM'
}

/**
 * @description: 新用户
 */
export const ACTIVATE_TYPE = {
  UNLIMITED: 0,
  WITH_IN_A_MONTH: 'WITH_IN_A_MONTH',
  ONE_MONTH_2_THREE_MONTH: 'ONE_MONTH_2_THREE_MONTH',
  THREE_MONTH_EAILIER: 'THREE_MONTH_EAILIER'
}

/**
 * @description: 手机品牌
 */
export const BRAND_TYPE = {
  UNLIMITED,
  CUSTOM: 'CUSTOM'
}

/**
 * @description: 手机价格类型
 */
export const PRICE_TYPE = {
  UNLIMITED,
  CUSTOM: 'CUSTOM'
}

/**
 * @description: 头条定向包版本，内部字段，不提交到媒体后台
 */
export const TOUTIAO_AD_MARKETING_SCENE = {
  VERSION_2: 'VERSION_TOUTIAO_2.0',
  VERSION_3: 'VERSION_TOUTIAO_3.0'
}

/**
 * @description: 定向包列表接口的头条定向类型
 */
export const TOUTIAO_TARGETING_TYPE = {
  VERSION_2: '4',
  VERSION_3: '5'
}

export const TOUTIAO_TARGETING_SCENE_LABELS = {
  [TOUTIAO_AD_MARKETING_SCENE.VERSION_2]: '头条2.0定向',
  [TOUTIAO_AD_MARKETING_SCENE.VERSION_3]: '头条智擎定向'
}

export const getToutiaoAdMarketingSceneByVersion = (isV3 = false) =>
  isV3 ? TOUTIAO_AD_MARKETING_SCENE.VERSION_3 : TOUTIAO_AD_MARKETING_SCENE.VERSION_2

export const getToutiaoTargetingTypeByVersion = (isV3 = false) =>
  isV3 ? TOUTIAO_TARGETING_TYPE.VERSION_3 : TOUTIAO_TARGETING_TYPE.VERSION_2
